<template>
 <v-container fluid>
    <v-row>
    <v-col lg="8" offset-lg="2">
      <v-container>
        <v-row>
          <v-col lg="12">
            <v-card flat>
              <v-card-text >
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="12" md="6" lg="6" class="enquiry-form text-left" :class="styleFontTopic">
                      <h3 >{{enquiry.reservation_form}}</h3>
                      <br>
                      <v-form ref="form" v-model="valid" lazy-validation :class="styleFontBody">
                        <v-row dense no-gutters>
                          <v-col cols="12">
                            <v-select
                              prepend-icon="mdi-check-circle"
                              :label="enquiry.input['0'].text"
                              :items="enquiry.input['0'].value"
                              :rules="isOwner"
                              required
                              v-model="form.is_owner"
                              outlined 
                              dense no-gutters
                             
                            ></v-select>
                          </v-col>
                        </v-row>

                        <v-row dense no-gutters >
                          <v-col cols="12">
                            <v-text-field
                              outlined
                              dense no-gutters
                              prepend-icon="mdi-account"
                              v-model="form.name"
                              :rules="nameRules"
                              :label="enquiry.input[1].text"
                              required
                              
                            ></v-text-field>
                          </v-col>
                        </v-row>

                        <v-row dense no-gutters>
                          <v-col cols="12">
                            <v-text-field
                              prepend-icon="mdi-email"
                              v-model="form.email"
                              :rules="emailRules"
                              :label="enquiry.input[2].text"
                              required
                              outlined 
                              dense no-gutters
                            ></v-text-field>
                          </v-col>
                        </v-row>

                        <v-row dense no-gutters >
                          <v-col cols="12">
                            <v-text-field
                              prepend-icon="mdi-phone"
                              v-model="form.tel"
                              :rules="telRules"
                              :label="enquiry.input[3].text"
                              required
                              outlined 
                              dense no-gutters
                            ></v-text-field>
                          </v-col>
                        </v-row>

                        <v-row dense no-gutters>
                          <v-col cols="12">
                            <v-select
                              prepend-icon="mdi-home"
                              v-model="form.resort"
                              :items="resorts"
                              :rules="[v => !!v || enquiry.input[4].required]"
                              :label="enquiry.input[4].text"
                              item-text="text"
                              item-value="text"
                              required
                              self-align="left"
                              @change="onChangeResort"
                              outlined 
                              dense no-gutters
                            ></v-select>
                          </v-col>
                        </v-row>

                        <v-row dense no-gutters > 
                          <v-col cols="12">
                            <v-select
                              prepend-icon="mdi-domain"
                              v-model="form.room"
                              :items="rooms"
                              :rules="[v => !!v || enquiry.input[5].required]"
                              :label="enquiry.input[5].text"
                              item-text="name"
                              return-object
                              :no-data-text="enquiry.input[5].no_data_select"
                              @change="onChangeRoomType"
                              required
                              outlined 
                              dense no-gutters
                            ></v-select>
                            {{form.room}}
                          </v-col>
                        </v-row>

                        <v-row dense no-gutters>
                          <v-col lg="6" md="6" sm="12">
                            <v-select
                              prepend-icon="mdi-account-multiple"
                              :label="enquiry.input[6].text"
                              :items="amount_guest"
                              :rules="adultRules"
                              v-model="form.number_of_adult"
                              required
                              outlined dense
                            ></v-select>
                          </v-col>
                          <v-col lg="6" md="6" sm="12">
                            <v-select
                              prepend-icon="mdi-human-child"
                              :label="enquiry.input[7].text"
                              :items="enquiry.input[7].value"
                              v-model="form.number_of_children"
                              outlined dense
                            ></v-select>
                          </v-col>
                        </v-row>

                        <v-row dense no-gutters >
                          <v-col lg="6" md="6" sm="12">
                            <v-dialog
                              ref="dialogCheckIn"
                              v-model="modalIn"
                              :return-value.sync="form.checkin_date"
                              persistent
                              width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  v-model="form.checkin_date"
                                  :label="enquiry.input[8].text"
                                  prepend-icon="event"
                                  readonly
                                  v-on="on"
                                  outlined
                                  dense no-gutters
                                ></v-text-field>
                              </template>
                              <v-date-picker 
                                v-model="form.checkin_date" 
                                scrollable  
                                show-current
                                :min="minCheckInDate" 
                              >
                                <v-spacer></v-spacer>
                                <v-btn text color="primary" @click="modalIn = false">Cancel</v-btn>
                                <v-btn
                                  text
                                  color="primary"
                                  @click="onChangeCheckInDate"
                                >OK</v-btn>
                              </v-date-picker>
                            </v-dialog>
                          </v-col>

                          <v-col lg="6" md="6" sm="12">
                            <v-dialog
                              ref="dialogCheckOut"
                              v-model="modalOut"
                              :return-value.sync="form.checkout_date"
                              persistent
                              width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  v-model="form.checkout_date"
                                  :label="enquiry.input[9].text"
                                  prepend-icon="event"
                                  readonly
                                  v-on="on"
                                  outlined
                                  dense no-gutters
                                ></v-text-field>
                              </template>
                              <v-date-picker v-model="form.checkout_date" scrollable :min="minCheckOutDate">
                                <v-spacer></v-spacer>
                                <v-btn text color="primary" @click="modalOut = false">Cancel</v-btn>
                                <v-btn
                                  text
                                  color="primary"
                                  @click="onChangeCheckOutDate"
                                >OK</v-btn>
                              </v-date-picker>
                            </v-dialog>
                          </v-col> 
                        </v-row>

                         <v-btn id="enquiry" color="#b3a258" style="color: #fff; font-size: 1.0em;" @click="validate" :loading="btnSaveLoading">{{enquiry.input[10].text}}</v-btn>
                        
                      </v-form>
                      <br>
                      
                    </v-col>
                    <v-col cols="12" sm="12" md="6" lg="6" class="enquiry-text text-left" style="padding-left: 20px;"  :class="styleFontBody">
                      <h3> <v-icon >mdi-phone</v-icon>&nbsp;&nbsp;{{enquiry.call_us_now}}</h3>
                      <br />
                      <p > {{enquiry.call_us_now_detail}} </p>

                      <p>
                        
                        <b>{{enquiry.register_code}}</b> <span class="link">A-EXPLORE</span> <br>
                        <b>{{enquiry.tel}}</b> <a href="tel:+66 (0)76 337 255" class="link">+66 (0)76 337 255</a> <br>
                        <b>{{enquiry.email}}</b> <a href="mailto:info@anantaraclub.com" class="link">info@anantaraclub.com</a><br>
                        <br>
                        <b >{{enquiry.toll_free_numbers}}</b>
                        <br>
                        <ul style="list-style-type: none;">
                          <li v-for="(data, index) in enquiry.toll_free_numbers_detail" :key="index" style="text-indent: -14px;">
                            <b>{{data.text}}</b>
                            <span v-html="data.value"></span>
                          </li>
                          <li></li>
                          <li></li>
                          
                        </ul>
                        <br>
                        <b style="font-size: .8em;">{{enquiry.working_hours}}</b>
                       
                      </p>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-col>
  </v-row>
 </v-container>
</template>

<script>
const axios = require("axios").default;

export default {
  name: "Enquiry",
  components: {},
  data() {
    return {
      lang: this.$route.params.lang,
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      modalIn: false,
      modalOut: false,
      menu2: false,
      valid: true,
      name: "",
      result: [],
      isOwner: [
        v => v != '' || this.enquiry.input[0].required,
        v => v != "Yes" || this.enquiry.input[0].required_yes
      ],
     
      nameRules: [
        v => !!v || this.enquiry.input[1].required
        // v => (v && v.length <= 10) || "Name must be less than 10 characters"
      ],
      emailRules: [
        v => !!v || this.enquiry.input[2].required,
        v => /.+@.+\..+/.test(v) || "E-mail must be valid"
      ],
      telRules: [
        v => !!v || this.enquiry.input[3].required
        // v => (v && v.length <= 10) || "Name must be less than 10 characters"
      ],
      adultRules: [v => !!v || this.enquiry.input[6].required],
      select: null,
      numberOfAdults: [1, 2, 3, 4, 5, 6],
      numberOfChildrens: [1, 2],
      checkbox: false,
      resorts: [],
      rooms: [],
      btnSaveLoading: false,
      minCheckInDate: new Date().toISOString(),
      minCheckOutDate: new Date().toISOString(),
      form: {
        is_owner: "",
        resort: "",
        room: "",
        name: "",
        email: "",
        tel: "",
        checkin_date: new Date().toISOString().substr(0, 10),
        checkout_date: new Date().toISOString().substr(0, 10),
        number_of_adult: "",
        number_of_children: "",
        lang: ''
      },
      amount_guest: [],
      enquiry: {},
      styleFontTopic: {},
      styleFontBody: {}
    };
  },
  methods: {
    async validate() {
      let _this = this;
      if (_this.$refs.form.validate()) {
        _this.btnSaveLoading = true;
        _this.form.lang = _this.lang;
        axios.post('https://job.anantaravacationclub.com/public/aexplore', _this.form)
        // eslint-disable-next-line no-unused-vars
        .then(res => {
         
          _this.btnSaveLoading = false;
        
          if(res.data.status == true) {
           
            _this.$router.push({name: "thankyou", params: { lang: this.lang }});
          }
        });
      }
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    async getResort() {
      let self = this;
      axios
        .get("/data/destination/resort-"+this.lang+".json")
        // eslint-disable-next-line no-unused-vars
        .then(res => {
          self.resorts = res.data;
        });
    },
    loadData() {
      let self = this;
      axios
        .get("/data/enquiry/"+this.lang+".json")
        // eslint-disable-next-line no-unused-vars
        .then(res => {
          self.enquiry = res.data;
        });
    },
    loadStyle() {
      if (this.lang == 'th') { 
        this.styleFontTopic = {"th": true, "th-topic": true};
        this.styleFontBody = {"th": true};
      }
    },
    onChangeResort() {
      let self = this;
      let dataFile = "/data/destination";
      if (self.form.resort == "Anantara Vacation Club Mai Khao Phuket" || 
          self.form.resort == "普吉岛迈考安纳塔拉度假会" || 
          self.form.resort == "อนันตรา เวเคชั่น คลับ ไม้ขาว ภูเก็ต") {
        dataFile = dataFile + "/phuket/room-type-"+this.lang+".json";
      } else if (self.form.resort == "Anantara Vacation Club Chiang Mai" ||
        self.form.resort == "清迈安纳塔拉度假会" ||
        self.form.resort == "อนันตรา เวเคชั่น คลับ เชียงใหม่" ) {
        dataFile = dataFile + "/chiang-mai/room-type-"+this.lang+".json";
      } else if (self.form.resort == "Anantara Vacation Club at Avani Seminyak Bali" ||
        self.form.resort == "巴厘岛水明漾安凡尼安纳塔拉度假会" ||
        self.form.resort == "อนันตรา เวเคชั่น คลับ ณ อวานี เซมินยัก บาหลี" ) {
        dataFile = dataFile + "/seminyak-bali/room-type-"+this.lang+".json";
      } else if (self.form.resort == "Anantara Vacation Club Bophut Koh Samui" ||
        self.form.resort == "苏梅岛博普安纳塔拉度假会" ||
        self.form.resort == "อนันตรา เวเคชั่น คลับ บ่อผุด เกาะสมุย" ) {
        dataFile = dataFile + "/koh-samui-resort/room-type-"+this.lang+".json";
      } else if (self.form.resort == "Anantara Vacation Club at Riverside Bangkok" ||
        self.form.resort == "曼谷河畔安纳塔拉度假会" ||
        self.form.resort == "อนันตรา เวเคชั่น คลับ ณ อนันตรา ริเวอร์ไซด์ กรุงเทพฯ" ) {
        dataFile = dataFile + "/riverside-bangkok/room-type-"+this.lang+".json";
      } else if (self.form.resort == "Anantara Vacation Club Legian Bali" ||
        self.form.resort == "巴厘岛雷吉安安纳塔拉度假会" ||
        self.form.resort == "อนันตรา เวเคชั่น คลับ เลเกียน บาหลี" ) {
        dataFile = dataFile + "/legian-bali/room-type-"+this.lang+".json";
      }
      axios
        .get(dataFile)
        // eslint-disable-next-line no-unused-vars
        .then(res => {
          self.rooms = res.data;
        });
    },
    onChangeRoomType() {
      this.amount_guest = this.form.room.amount_guest;
      this.form.room = this.form.room.name;
    },
    onChangeCheckInDate() {
      this.$refs.dialogCheckIn.save(this.form.checkin_date);
      let date = new Date(this.form.checkin_date);
      date.setDate(date.getDate() + 1);
      date = date.toISOString().substr(0, 10);
      this.minCheckOutDate = date;
      this.form.checkout_date = date;
    },
    onChangeCheckOutDate() {
      this.$refs.dialogCheckOut.save(this.form.checkout_date);
    }
  },

  mounted() {
    this.getResort();
    this.loadData();
    this.loadStyle();
  }
};
</script>

<style scoped lang="sass">
.link 
  color: #b3a258
  text-decoration: none

.enquiry-text 
  border: 0px solid #000 
  padding: 25px 50px 0 0

.enquiry-form 
  padding: 25px 50px 0 0


 
@media only screen and (max-width: 567px) 
  .enquiry-text 
    border: 0px solid #000 
    padding: 0 5px 0 5px
  
  .enquiry-form 
    padding: 0 5px 0 5px
    
</style>